import {
  NOT_ADICIONA_NOTIFICACAO_SUCCESS,
  NOT_ATUALIZA_NOTIFICACOES_SUCCESS,
  NOT_NOTIFICACOES_SUCCESS,
  NOT_TOTAL_NOTIFICACAO_NAO_LIDA,
  NOT_MARCAR_TODAS_NOTIFICOES_LIDAS,
} from '../actions/types';

const INITIAL_STATE = {
  notificacoes: [],
  notificacoesNaoLidas: 0,
  totalNotificacoes: 0,
};

export default function(state = INITIAL_STATE, action) {
  switch (action.type) {
    case NOT_ATUALIZA_NOTIFICACOES_SUCCESS:
    case NOT_NOTIFICACOES_SUCCESS:
      const {
        data: notificacoes,
        notificationsCount: notificacoesNaoLidas,
        count: totalNotificacoes,
      } = action.payload;

      return {
        ...state,
        notificacoes: [...state.notificacoes, ...notificacoes],
        notificacoesNaoLidas,
        totalNotificacoes,
      };
    case NOT_ADICIONA_NOTIFICACAO_SUCCESS:
      return {
        ...state,
        notificacoes: [action.payload, ...state.notificacoes],
        notificacoesNaoLidas: state.notificacoesNaoLidas + 1,
      };
    case NOT_TOTAL_NOTIFICACAO_NAO_LIDA:
      return { ...state, notificacoesNaoLidas: action.payload };
    case NOT_MARCAR_TODAS_NOTIFICOES_LIDAS:
      const { data, notificationsCount, count } = action.payload;
      return {
        ...state,
        notificacoes: [...data],
        notificacoesNaoLidas: notificationsCount,
        totalNotificacoes: count,
      };
    default:
      return state;
  }
}
